/**
 * Marks every surface the update sheet's camera puts on screen, so the sheet
 * underneath can tell a tap on the camera from a tap outside the sheet.
 */
export const ISSUE_CAMERA_ATTR = "data-issue-camera";

/**
 * Whether a DOM event landed on the issue camera or its discard prompt. The
 * sheet uses it to refuse the outside-press dismissal the camera would
 * otherwise trigger — both render outside the sheet's own tree.
 */
export function isInsideIssueCamera(target: EventTarget | null): boolean {
  return (
    target instanceof Element &&
    target.closest(`[${ISSUE_CAMERA_ATTR}]`) !== null
  );
}

/** Whether the issue camera is on screen at all. */
export function isIssueCameraOpen(): boolean {
  return document.querySelector(`[${ISSUE_CAMERA_ATTR}]`) !== null;
}
